import { createApp } from 'vue';
import App from "./App.vue";
import router from "./router";
import { store } from "./store";
import VueAxios from 'vue-axios';
import { securedAxiosInstance, plainAxiosInstance} from './backend/axios';
import { is_it_client_whirlpool_type, is_it_client_reliance_type } from './backend/axios/organisation_config'

import { initializeLabelChanges } from './globalLabelChange';
import GlobalTooltip from './components/commoncomponents/GlobalTooltip.vue';
import AgeingTooltip from './components/commoncomponents/AgeingTooltip.vue';
import PaginationComponent from './components/commoncomponents/PaginationComponent.vue';
import DropdownButton from './components/commoncomponents/customizedcomponent/DropdownButton.vue';  


import { createVuetify } from 'vuetify';
import 'vuetify/styles';
import 'vuetify/dist/vuetify.min.css';
import * as components from 'vuetify/components';
import * as directives from 'vuetify/directives';
import * as labsComponents from "vuetify/labs/components";
import 'bootstrap-vue-3/dist/bootstrap-vue-3.css';
import { BootstrapVue3 } from 'bootstrap-vue-3';

import VueToast from "vue-toast-notification";
import "vue-toast-notification/dist/theme-default.css";

import "./assets/css/font-awesome.min.css";
import "./assets/css/style.css";
import "./assets/css/annotorious.css";
// import "./assets/javascript/annotorious.min.js";
import "./assets/css/custom.css";

import TooltipDirective from './directives/v-tooltip.js';
import GradingLibrary from 'grading-library'
import "grading-library/grading-library.css";
import noEdgeSpace from "./directives/noEdgeSpace";
const app = createApp(App)
app.component('AgeingTooltip', AgeingTooltip);
app.component('GlobalTooltip', GlobalTooltip);
app.component('PaginationComponent', PaginationComponent);
app.component('DropdownButton', DropdownButton);

app.directive('tooltip', TooltipDirective);
app.directive('no-edge-space', noEdgeSpace);

const vuetify = createVuetify({
  components: {
    ...components,
    ...labsComponents,
  },
  directives,
});
app.use(BootstrapVue3);
app.use(GradingLibrary);

app.use(VueAxios, {
  $httpSecured: securedAxiosInstance,
  $httpPlain: plainAxiosInstance,
});
app.config.globalProperties.$isWhirlpoolClient = is_it_client_whirlpool_type;
app.config.globalProperties.$isRelianceClient = is_it_client_reliance_type;
app.use(VueToast, { position: "top" });
app.use(router);
app.use(store);
app.use(vuetify);
initializeLabelChanges(app);
app.mount('#app');
